<template>
  <div class="well">
    <div class="search-filter">
      <h2 class="filter-header">Student's Grade</h2>
      <A11yDropdown
        :dropdown-props="{
          ref:'grade-dropdown',
          class: 'browse-subject-dropdown',
        }"
        :button-props="{
          class: 'btn btn-default dropdown-toggle ellipsis',
          'data-role': 'trigger',
          'aria-label': 'Student\'s Grade'
        }"
        :dom-attributes="{
          role: 'listbox',
          id: 'grade-select',
          'aria-label': 'Student\'s Grade'
        }"
      >
        <template slot="button-contents">
          {{ currentGradeData ? currentGradeData.name : chooseGradeString }} <i class="fa fa-caret-down" />
        </template>
        <template slot="dropdown-items">
          <li
            v-for="grade in gradeOptions"
            :key="`grade-option-${grade.val}`"
            role="option"
            @click="updateSelectedGradeValue(grade.val)">
            <a
              class="subject-option"
              :title="grade">
              {{ grade.name }}
            </a>
          </li>
        </template>
      </A11yDropdown>
    </div>

    <div class="search-filter">
      <h2 class="filter-header">Subjects</h2>
      <A11yDropdown
        :dropdown-props="{
          ref:'subject-dropdown',
          class: 'browse-subject-dropdown',
        }"
        :button-props="{
          class: 'btn btn-default dropdown-toggle ellipsis',
          'data-role': 'trigger',
          'aria-label': 'Subjects'
        }"
        :dom-attributes="{
          role: 'listbox',
          'aria-label': 'Subjects'
        }"
      >
        <template slot="button-contents">
          {{ currentSubjectData ? currentSubjectData.label : chooseSubjectString }} <i class="fa fa-caret-down" />
        </template>
        <template slot="dropdown-items">
          <li
            v-for="subject in subjectOptions"
            :key="`subject-option-${htmlIDFromString(subject.value)}`"
            role="option"
            @click="updateSelectedSubjectValue(subject.value)">
            <a
              class="subject-option"
              :title="subject.label">
              {{ subject.label }}
            </a>
          </li>
        </template>
      </A11yDropdown>
    </div>

    <fieldset class="search-filter" v-if="categoryOptions.length">
      <legend class="filter-header">Categories</legend>
      <div
        :class="{
          'label-toggle': true,
          'subject-domain-option': true,
          'selected': category.skill_uuid === selectedCategoryValue,
          disabled: category.locked
        }"
        v-for="category in categoryOptions"
        :key="`category-option-${category.skill_uuid}`">
        <LockableInputWrapper :locked="category.locked">
          <input
            type="radio"
            name="category"
            :value="category.skill_uuid"
            v-model="selectedCategoryValueInternal"
            @change="!category.locked && updateSelectedCategoryValue(category.skill_uuid)"
            :id="`category-option-${category.skill_uuid}`">
          <label
            slot="label"
            :for="`category-option-${category.skill_uuid}`"
            @keydown.enter="!category.locked && updateSelectedCategoryValue(category.skill_uuid)"
            tabindex="0"
            :class="{'cursor-not-allowed': category.locked}"
          >
            {{ category.skill_name }}
          </label>
        </LockableInputWrapper>
      </div>
    </fieldset>
  </div>
</template>

<script>
import RedundantRouteMixin from '@/components/RedundantRouteMixin';
import {htmlIDFromString} from '@/util/html_utils.js';
import A11yDropdown from '@/components/A11yDropdown'
import { PremiumLocksMixin } from '@/contentprofile/premium_locks_mixin'
import LockedOption from '@/components/LockedOption.vue'
import LockableInputWrapper from '@/components/LockableInputWrapper.vue'

export default {
  name: 'BrowsePresentLevelsFilters',
  components: { LockableInputWrapper, LockedOption, A11yDropdown },
  mixins: [RedundantRouteMixin, PremiumLocksMixin],
  data() {
    return {
      selectedCategoryValueInternal: this.selectedCategoryValue || '',
      chooseGradeString: 'Choose a grade',
      chooseSubjectString: 'Choose a subject'
    }
  },
  props: {
    gradeOptions: {
      type: Array,
      default() {
        return [];
      }
    },
    selectedGradeValue: {
      type: String,
      default: ''
    },
    subjectOptions: {
      type: Array,
      default() {
        return []
      }
    },
    selectedSubjectValue: {
      type: String,
      default: ''
    },
    categoryOptions: {
      type: Array,
      default() {
        return []
      }
    },
    selectedCategoryValue: {
      type: String,
      default: ''
    },
  },
  computed: {
    currentGradeData() {
      return this.gradeOptions.find(gradeData => gradeData.val === this.selectedGradeValue)
    },
    currentSubjectData() {
      return this.subjectOptions.find(subjectData => subjectData.value === this.selectedSubjectValue)
    },
    currentCategoryData() {
      return this.categoryOptions.find(categoryData => categoryData.val === this.selectedCategoryValue)
    },
  },
  methods: {
    updateSelectedGradeValue(value) {
      this.$emit('update:selectedGradeValue', value)
      this.$sendEvent('Selected Browse Present Levels Grade')
    },
    updateSelectedSubjectValue(value) {
      this.$emit('update:selectedSubjectValue', value)
      this.$sendEvent('Selected Browse Present Levels Subject')
    },
    updateSelectedCategoryValue(value) {
      this.$emit('update:selectedCategoryValue', value)
      this.$sendEvent('Selected Browse Present Levels Category')
    },
    htmlIDFromString
  },
  watch: {
    selectedCategoryValue(newValue) {
      this.selectedCategoryValueInternal = newValue
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';
@import '~@/components/search/browsestyles.less';
.label-toggle.subject-domain-option {
  padding: 0.25rem 0.75rem;
  color: @gray-dark;

  &.selected {
    background: @plPurple;
  }
  /deep/ input[type='radio'] {
    display: none;
  }
  label {
    margin: 0;
    width: 100%;
    padding: 0.15rem;
    cursor: pointer;
  }
  .lockable-input-wrapper{
    /deep/ .lockable-input:not(.locked) {
        margin-right: 0;
    }
    label.cursor-not-allowed {
      margin-left: 0.5rem;
    }
  }
}
.filter-header {
  border: none;
}
</style>
